import { useState } from 'react'
import { Select, Input } from '@bitcine/cinesend-theme'
import { formatFileSize, convertToBytes } from '../../helpers/human_file_size'

const AirlineSnapshotSizeInput = ({ fieldName, value, label, saveModel }) => {
  const maxTotalSnapshotSize = formatFileSize(value)
  const [maxTotalSnapshotSizeState, setMaxTotalSnapshotSizeState] = useState({
    size: maxTotalSnapshotSize?.size || 0,
    unit: maxTotalSnapshotSize?.unit || 'MB',
  })
  const updateState = (newState) => {
    const updatedState = { ...maxTotalSnapshotSizeState, ...newState }
    const bytes = convertToBytes(updatedState.size, updatedState.unit)

    setMaxTotalSnapshotSizeState(updatedState)

    saveModel({ [fieldName]: bytes })
  }
  const unitsWithLabels = ['KB', 'MB', 'GB', 'TB'].map((opt, i) => ({ label: opt, value: i }))
  return (
    <div className='flex items-center space-x-2'>
      <Input
        type='number'
        label={label}
        value={maxTotalSnapshotSizeState.size}
        onChange={(e) => {
          setMaxTotalSnapshotSizeState({
            size: e.target.value,
            unit: maxTotalSnapshotSizeState.unit,
          })
        }}
        onBlur={() => updateState({ size: maxTotalSnapshotSizeState.size })}
      />
      <Select
        label='&nbsp;'
        options={unitsWithLabels}
        value={unitsWithLabels?.find((opt) => opt.label === maxTotalSnapshotSizeState.unit)}
        onChange={(v) => {
          updateState({ unit: v.label })
        }}
      />
    </div>
  )
}

export default AirlineSnapshotSizeInput
